import { ModelApiService } from './BaseApiService'

export default class CandidateApiService extends ModelApiService {
  constructor() {
    super('candidate')
  }

  async getCandidateDetails(id) {
    return this.get(`${id}/details`)
  }

  getCandidateListByClientIds(clientIds = []) {
    return this.post(`candidatelist`, {
      clientIds,
    })
  }

  async getDisplayPic(id, options = {}) {
    if (id && id >= 0) {
      const headers = {}
      if (options.signal) {
        headers.signal = options.signal
      }
      return this.get(`${id}/profile-image`, null, headers)
    }
  }

  async getCandidates(payload) {
    return await this.post('candidates', payload)
  }
}
